import type { PaymentMethodsProps } from "store/modules/DealerCare/types.store";

export function parsePaymentMethodsFromBillingResponse(
  raw: unknown,
): PaymentMethodsProps[] {
  if (Array.isArray(raw)) return raw as PaymentMethodsProps[];
  if (raw && typeof raw === "object") {
    const d = (raw as { data?: unknown }).data;
    if (Array.isArray(d)) return d as PaymentMethodsProps[];
  }
  return [];
}
